import React from 'react';
import Vendors from './Vendors';

// Seller lens: Teaming reuses the vendor knowledge base + FIT matching engine,
// reframed as finding TEAMING PARTNERS for a pursuit. When matching runs on a
// seller pursuit (pursuit_side='seller'), the backend interprets FIT as
// partner-complement fit and surfaces teaming recommendations.
export default function Teaming() {
  return (
    <div>
      <div style={{
        background: 'linear-gradient(135deg, #eef2ff 0%, #f8fafc 100%)',
        border: '1px solid #e2e8f0', borderRadius: 12, padding: '14px 18px', marginBottom: 18,
      }}>
        <div style={{ fontSize: 15, fontWeight: 700, color: '#1e293b' }}>Find teaming partners</div>
        <div style={{ fontSize: 13, color: '#475569', marginTop: 4 }}>
          Identify vendors whose capabilities complement yours for a pursuit. Run FIT matching on a
          seller pursuit to see partner recommendations and the gaps each partner fills.
        </div>
      </div>
      <Vendors />
    </div>
  );
}
